import React, { useEffect } from "react";
import { useAuthState } from "react-firebase-hooks/auth";
import { useNavigate } from "react-router-dom";
import { auth } from "../services/firebase/firebase";


const MainLayout = ({ children }) => {
    const [user, loading, error] = useAuthState(auth);
    const navigate = useNavigate()


    useEffect(() => {
        if (loading) {
            // maybe trigger a loading screen
            return;
        }
        if (!user) {
            navigate("/");
            return;
        }
        // Check if user is admin and navigate to /admin
    }, [user, loading])
    return (
        <main className="h-100">
            {children}
        </main>
    )
}

export default MainLayout